import { PurchasesUrlQueryParams } from "./../APICalls/buildGetPurchasesUrl";
import useSWR from "swr";

import buildGetPurchasesUrl from "../APICalls/buildGetPurchasesUrl";
import getData from "../APICalls/getData";
import { mapPurchasesData } from "../Mappers/mapPurchasesData";
import SortOption from "../Interfaces/SortOption";
import Filter from "../Interfaces/Filter";
import processUISortOptions from "../Mappers/processUISortOptions";
import getPageViewDataPush from "../AdobeDataPushes/pageViewDataPush";
import User from "../Interfaces/User";
import { AppliedCheckbox } from "./useAppliedCheckBoxes";
import { useAuth } from "@bca-auth0/bca-auth0-provider";

const selectData = (isLoading: boolean, data: any) => {
  let filters = [];
  let purchasesData = [];
  let selectedFilterLabel = null;
  let totalResultCount = 0;
  let totalPages = 0;
  let degradedServices = [];
  let sortOptions = [];
  let selectedSortOption = null;
  let selectedSortOptionLabel = "";
  if (!isLoading) {
    filters = data.dateRangeOptions.options;
    purchasesData = mapPurchasesData(data).vehicles;
    selectedFilterLabel = filters.find(
      (el: Filter) => el.key === data.dateRangeOptions.selected
    ).label;
    totalResultCount = data.totalResultCount;
    totalPages = data.totalPages;
    degradedServices = data.degradedServices;
    sortOptions = processUISortOptions(data.sortOptions.options);
    selectedSortOption = data.sortOptions.selected;
    selectedSortOptionLabel = sortOptions.find(
      (el: SortOption) => el.key === data.sortOptions.selected
    ).label;
  }
  return {
    filters,
    purchasesData,
    totalPages,
    totalResultCount,
    degradedServices,
    sortOptions,
    selectedSortOption,
    selectedSortOptionLabel,
    selectedFilterLabel,
  };
};

export function useGetPurchases(
  purchasesUrlQueryParams: PurchasesUrlQueryParams,
  isClientSide: boolean,
  user: User,
  isToUseAuthZero: boolean,
  initialLoad: boolean,
  appliedCheckboxes?: AppliedCheckbox[]
) {
  const { accessToken } = useAuth(!isToUseAuthZero);
  const getPurchasesUrl = buildGetPurchasesUrl(purchasesUrlQueryParams, isToUseAuthZero);
  const shouldCallAPI =
  isClientSide && (accessToken || !isToUseAuthZero) ? getPurchasesUrl : null;

  const swrKey = shouldCallAPI
  ? [shouldCallAPI, accessToken, isToUseAuthZero]
  : null;

  const { data, error } = useSWR(swrKey, getData, {
    onSuccess: (res) => {
      getPageViewDataPush(
        purchasesUrlQueryParams,
        user,
        initialLoad,
        res,
        appliedCheckboxes
      );
    },
    onError: () => {
      getPageViewDataPush(purchasesUrlQueryParams, user, initialLoad);
    },
    revalidateOnFocus: false,
  });

  const isLoading = !Boolean(data);
  const {
    filters,
    purchasesData,
    selectedFilterLabel,
    totalPages,
    totalResultCount,
    degradedServices,
    sortOptions,
    selectedSortOption,
    selectedSortOptionLabel,
  } = selectData(isLoading, data);

  return {
    isLoading,
    filters,
    purchasesData,
    degradedServices,
    selectedFilterLabel,
    totalPages,
    totalResultCount,
    error,
    sortOptions,
    selectedSortOption,
    selectedSortOptionLabel,
  };
}
